<div>
    <app-header></app-header>
</div>
<section class="main_comp pt-xl-4 p-2 home">
    <section class="my-3">
        <div class="container-fluid">
            <div class="row custom-row">
                <div class="col-md-4 md-screen-padding">
                    <div class="boxgrey">
                        <div class="row"> 

                            <div class="col-md-12">
                                <div class="d-flex justify-content-between pb-0 pb-sm-3">
                                    <h4> Newly Arrival</h4>
                                    <p class="ctabtn" (click)="navigateNewlyArrival()" style="display: inline-block;"> View All</p>
                                </div>
                            </div>
                          
                            <div class="col-md-6 col-sm-6 newly-mob-view" *ngFor="let product of homeListdata?.newArrivals">

                                <div class="newly50 imgheight2" (click)="navigateTonewArrival(product?.industry_id)">
                                    <span class="newtick mobile-new-head"> New</span>
                                    <!-- <img *ngIf="product.Media && product.Media.length > 0; else fallbackImage"
                                    [src]="domUrls + product.Media[0]?.url" class="product-image img-fluid imgborder"
                                    alt="{{ product.title }}" (click)="viewhomeProduct(product.id)" /> -->
                                    <div class="imgbox250">
                                        <img *ngIf="product.Media && product.Media.length > 0; else fallbackImage"
                                            [src]="product.Media[0]?.url" class="product-image img-fluid imgborder"
                                            alt="{{ product.title }}" />

                                        <!-- <img src="https://picsum.photos/200" class="" alt="box">  -->
                                    </div>
                                    <ng-template #fallbackImage>
                                        <img src="assets/images/new_images/rated.jpg" class="img-fluid imgborder"
                                            alt="Rated" />
                                    </ng-template>

                                    <div class="newlyetail">
                                        <div class="catServices">{{ product?.Industry?.industry_name }}</div>
                                        <h6>{{ product.title }}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="col-md-4 md-screen-padding">

                    <div class="featuredbanner-slide topbanner">

                        <div class="trServices text-start">
                            <div >
                                <div class="imgbox500">
                                    <img src="/assets/images/hand-holding-gear.jpg" class="img-fluid" alt="slide"> 
                                </div>                               
                                <div class="trServicesDetail designbox" style="padding-bottom: 50px; text-align: center;">
                                    <h4>Platform for</h4>
                                     <h3> Manufacturing MSMEs</h3>
                                    <p> Buy, sell, or upgrade industrial machinery to the latest versions.</p>
                                    <a [href]="" (click)="navigateToAboutUs()" class="Registercta"> Know More</a>
                                </div> 
                            </div>                            
                        </div>


                        <!-- <div class="trServices text-start">
                            <div >
                                <div class="imgbox500">
                                    <img src="/assets/images/cnc-milling-machine-with-mill-chuck-preparing-process-metal-detail-workshop-area.jpg" class="img-fluid" alt="slide"> 
                                </div>                               
                                <div class="trServicesDetail designbox" style="padding-bottom: 50px;">
                                     <h4> Buying & Selling Machines</h4>
                                    <p> Best deals on machines (owned/pre-owned) you can trust</p>
                                    <a [href]="" (click)="navigateToAboutUs()" class="Registercta"> Register Now</a>
                                </div> 
                            </div>                            
                        </div>
  
                        <div class="trServices text-start">
                            <div >
                                <div class="imgbox500">
                                    <img src="/assets/images/industrial-metal-machining-with-sparks-shavings-high-resolution-manufacturing-process.jpg" class="img-fluid" alt="slide"> 
                                </div>                               
                                <div class="trServicesDetail designbox" style="padding-bottom: 50px;">
                                     <h4>Marketplace for Manufacturing MSMEs</h4>
                                    <p> Buy for new features, upgrade for efficiency</p>
                                    <a [href]="" class="Registercta"> Register Now</a>
                                </div> 
                            </div>                            
                        </div>
                        <div class="trServices text-start">
                            <div >
                                <div class="imgbox500">
                                    <img src="/assets/images/professional-engineer39s-dedication-industrial-scene-generative-by-ai.jpg" class="img-fluid" alt="slide"> 
                                </div>                               
                                <div class="trServicesDetail designbox" style="padding-bottom: 50px;">
                                     <h4>Flexible Financing</h4>
                                    <p>Tailored loans to boost your manufacturing business</p>
                                    <a [href]="" class="Registercta"> Register Now</a>
                                </div> 
                            </div>                            
                        </div>

                        <div class="trServices text-start">
                            <div >
                                <div class="imgbox500">
                                    <img src="/assets/images/happy-indian-people-team-worker-inventory-talking-consulting-together-warehouse-staff-friend-work.jpg" class="img-fluid" alt="slide"> 
                                </div>                               
                                <div class="trServicesDetail designbox" style="padding-bottom: 50px;">
                                     <h4>Business Networking</h4>
                                    <p> Connect with peers, build partnerships, and grow together</p>
                                    <a [href]="" (click)="navigateToaboutus()" class="Registercta"> Register Now</a>
                                </div> 
                            </div>                            
                        </div> -->

                    </div>
                </div>

                <div class="col-md-4 md-screen-padding">
   
                    <div class="boxgrey popularBox">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="d-flex justify-content-between pb-3">
                                    <h4> Popular Categories</h4>
                                    <!-- <a  class="ctabtn" (click)="navigateToDetails()"> View All</a> --> 
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6 newly-mob-view">
                            <div class="newly50" (click)="navigateToProductListing('6d107209-573e-4a13-8c39-9eb299d16246','')">
                                <div class="imgbox250">
                             <img src="/assets/images/automated-packaging.jpg" class="product-image img-fluid imgborder" alt=" product" />
                                </div>
                                <div class="newlyetail">
                                <div class="catServices">
                                    Machine
                                    </div>
                                </div>
                            </div>
                        </div>
                            <div class="col-md-6 col-sm-6 newly-mob-view">
                            <div class="newly50" (click)="navigateToProductListing('0627f25d-6d56-4237-b561-d0ea9830acd7','89e8c3d0-c9b8-4a07-a8e1-61a8eb04716d')">
                                <div class="imgbox250">
                             <img src="/assets/images/industrial-property.jpg" class="product-image img-fluid imgborder" alt=" product" />
                                </div>
                                <div class="newlyetail">
                                <div class="catServices">
                                    Industrial property
                                    </div>
                                </div>
                            </div>
                        </div>
                            <div class="col-md-6 col-sm-6 newly-mob-view">
                            <div class="newly50" (click)="navigateToProductListing('0627f25d-6d56-4237-b561-d0ea9830acd7','9595821e-9d59-4218-b516-ed77d4aa7a76')">
                                <div class="imgbox250">
                             <img src="/assets/images/finance.jpg" class="product-image img-fluid imgborder" alt=" product" />
                                </div>
                                <div class="newlyetail">
                                <div class="catServices">
                                    Finance
                                </div>
                                </div>
                            </div>
                        </div>
                            <div class="col-md-6 col-sm-6 newly-mob-view">
                            <div class="newly50" (click)="navigateToProductListing('0627f25d-6d56-4237-b561-d0ea9830acd7','7e124a98-a33c-41f3-846a-b83b5f1c5d47')">
                                <div class="imgbox250">
                             <img src="/assets/images/hr.jpg" class="product-image img-fluid imgborder" alt=" product" />
                                </div>
                                <div class="newlyetail">
                                <div class="catServices">
                                    HR
                                </div>
                                </div>
                            </div>
                        </div>


                            <!-- <div class="col-md-6 col-sm-6 newly-mob-view"
                                *ngFor="let product of homeListdata?.popularCategories">
                                <div class="newly50" (click)="navigateToProductListing(product)">
                                    <div class="imgbox250">
                                        <img *ngIf="product.industryMedia && product.industryMedia.length > 0"
                                            [src]="product.industryMedia[0]?.url"
                                            class="product-image img-fluid imgborder"
                                            alt="{{ product.title || 'Rated' }}" />
                                    </div>
                                    <div class="newlyetail">
                                    <div class="catServices" *ngIf="product.industry_name == 'Machine'">
                                        {{ product.industry_name }}</div>
                                        <div class="catServices" *ngIf="product.industry_name == 'Services'"> Finance  </div>
                                            <div class="catServices" *ngIf="product.industry_name == 'Raw Material'"> Industrial property </div>
                                                <div class="catServices" *ngIf="product.industry_name == 'Tools'"> Tools  </div>

                                    </div>
                                </div>
                            </div> -->
                        </div>

                    </div>

                </div>
            </div>
        </div>  
    </section> 
    <!-- <section class="position-relative py-3 py-sm-5" *ngIf="homeListdata?.bestSellersServices?.length>0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3 mb-2 mb-sm-0">
                    <h2> Best Seller Services</h2>
                    <p style="opacity: 70%; font-weight: 400;" class=" mobile-view-margin"> We worked hard to ensure
                        that our list accurately
                        includes the companies with the best customer
                        service. </p>
                    <a class="ctabtn" (click)="navigateToDetails()"> View All </a>
                </div>
                <div class="col-md-9 remove-mobile-padd">
                    <div class="trsliders">
                        <div class="slick-slider">
                            <div class="trServices"
                                *ngFor="let product_service of homeListdata?.bestSellersServices; let i = index">
                                <span class="newtick">New</span>
                                <img *ngIf="product_service.Media && product_service.Media.length > 0"
                                    [src]="product_service.Media[0]?.url" class="product-image img-fluid imgborder"
                                    alt="{{ product_service.title }}" (click)="viewSingleProduct(product_service.id)" />

                                <div class="trServicesDetail">
                                    <div class="catServices mb-1"> {{product_service?.Industry?.industry_name}} </div>
                                    <h5 class="mb-1">{{ product_service.title }} </h5>
                                    <p class="location d-flex align-items-center mb-1"><span><img
                                                src="assets/images/new_img/location.svg" class="img-fluid me-2"
                                                alt="location"></span>
                                        <span> {{ product_service.location }}</span>
                                    </p>
                                    <div class="price">Price <span>{{ product_service.price }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section> -->
    <section class="py-1 py-sm-0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-7 service-mob-v md-screen-padding">
                    <div class="position-relative">
                        <img src="/assets/images/flexible-financing.jpg"
                            class="img-fluid borderradius img100 imgborder" alt="img">

                        <div class="boxToolsBox">
                            <div class="showdiv">
                                <div class="servicesinfo">Services</div>
                                <h2 class="mb-3 text-capitalize" style="color: #fff !important;"> Flexible Financing                                    
                                </h2>
                                <p style="color: #fff !important;"> Tailored loans to boost your manufacturing business </p>
                 <a (click)="navigateServices()" class="catBold cursorp">Know More</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 md-screen-padding">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="boxToolsmain position-relative mt-sm-3 mt-md-0 mb-3">
                                <img src="assets/images/technology.jpg"
                                    class="img-fluid borderradius img100 imgborder" alt="img">
                                <div class="boxTools">
                                    <div class="showdiv">
                                        <img src="assets/images/high-tech-machine.png"  class="img-fluid" alt="electronica">
                                        <!-- <div class="servicesinfo"> Raw Materials</div> -->
                                        <h5 class="mt-3 mb-3 text-capitalize">Drive your business forward <br/>  with
                                            innovative technology</h5>

                                        <a (click)="navigateStore('96f71904-bb05-4fe1-98dd-842095e0cecb')" style="cursor: pointer;" class="catBold">Know More </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="boxToolsmain position-relative mt-sm-3 mt-md-0">

                                <img src="assets/images/truck-driver.jpg"
                                    class="img-fluid borderradius img100 imgborder" alt="img">

                                <div class="boxTools ">
                                    <div class="showdiv">
                                        <img src="assets/images/electronica-logo.png"  class="img-fluid" alt="electronica">
                                        <!-- <div class="servicesinfo"> Tools</div> -->
                                        <h5 class="mt-3 mb-3 text-capitalize">Fueling Business Growth,  <br/> Empowering Dreams</h5>
                                        <a (click)="navigateStore('f9d790de-ddd7-4732-ba63-9d8531abf7a4')" class="catBold" style="cursor: pointer;">Know More</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    </div>

                </div>
            </div>

        </div>
    </section>
    <section class="position-relative py-sm-5 py-2"  *ngIf="isUserLoggedIn() &&  recentlyViewedItems.length>0">
        <div class="container-fluid py-sm-5 py-3" style="background: #F4F4F4;">
            <div class="row">
                <div class="col-md-3 mb-2 mb-sm-0">
                    <h2> Recently Searched Products</h2>
                    <p style="opacity: 70%; font-weight: 400;" class="mobile-view-margin">Take another look at the items
                        you've recently explored!
                    </p>
                    <a  class="ctabtn" (click)="navigateRecentlyToDetails()" style="display: inline-block;"> View All </a>
                </div>

                <!-- Loop over each service and create a slider for each -->
                <div class="col-md-9">
                    <div class="trsliders">
                        <!-- Each slick slider should have a unique class using index 'i' -->
                         
                        <div class="slick-slider">
                            <div class="p-2" *ngFor="let items of recentlyViewedItems; let i = index">
                                <div class="normalbox">
                                    <div (click)="viewSingleProduct(items.product_id)">
                                        <span class="newtick">New</span>
                                        <div class="normalboximg" *ngIf="items">
                                            <img *ngIf="items.Product.Media && items.Product.Media.length > 0"
                                                [src]="items.Product.Media[0]?.url" class="img-fluid normalimg"
                                                alt="{{ items.title }}" />

                                        </div>
                                        <div class="normalboxDetail">
                                            <!-- <div class="catServices">{{ items?.Product?.Industry?.industry_name }}</div> -->
                                            <!-- <h5>{{ items?.Product?.title }}
                                            </h5> -->
                                            <h5>
                                                {{ items?.Product?.Category3?.title === 'Other' 
                                                ? (items?.Product?.category3_name | titlecase) 
                                                : (items?.Product?.Category3?.title | titlecase) }}
                                            </h5>
                                            <!-- <p class="location d-flex align-items-center">
                           {{items?.Product?.UserAuth?.company_name}}
                                            </p> -->
                                            <p class="location d-flex align-items-center">
                                                <span *ngIf=" items?.Product?.stateDetails?.name"><img
                                                        src="assets/images/locations.svg"
                                                        class="img-fluid me-2" alt="location"></span>

                                <span *ngIf="items?.Product?.stateDetails?.name" class="c-price">{{
                                    items?.Product?.cityDetails?.city }}<span
                                    *ngIf="items?.Product?.cityDetails?.city != null && items?.Product?.cityDetails?.city != 'null'">,</span> {{
                                        items?.Product?.stateDetails?.name | titlecase }}</span>

                                             
                                            </p>

                                            <div class="price" *ngIf="items?.Product?.price != 'null' && items?.Product?.price != null">
                                                {{ items?.Product?.category1_id == '9595821e-9d59-4218-b516-ed77d4aa7a76' ? 'Max Loan Up To' : 'Price' }}
                                                <span class="pricebold c-price">{{ (items?.Product?.price) ? (' ₹ ' + (items?.Product?.price | commaSeparated)) + "/-" : 'On Request' }}</span>
                                                <!-- <span class="pricebold c-price">{{ items?.Product?.price | currency:'INR':'symbol':'1.0-0' }}/-</span> -->
                                                <!-- <span *ngIf="items?.punit">/{{items?.punit || ''}}</span> -->
                                              </div>

                                         
                                          
                                            <div class="ContactSeller mt-2">
                                                <a> Contact the Seller</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="position-relative py-5 pbottom-md-screen" *ngIf="isUserLoggedIn() &&  products.length>0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3">
                    <h2> Recommended Products</h2>
                    <p style="opacity: 70%; font-weight: 400;" class="mobile-view-margin">Handpicked recommendations
                        tailored just for you!</p>
                    <a  class="ctabtn" (click)="navigateRecommendedToDetails()" style="display: inline-block;"> View All </a>
                </div>
                <div class="col-md-9 md-screen-padding">
                    <div class="trsliders">
                        <div class="slick-slider">
                            <div class="p-2" *ngFor="let items of products; let i = index">
                                <div class="normalbox">
                                    <div (click)="viewSingleProduct(items.id)">
                                        <span class="newtick">New</span>
                                        <div class="normalboximg" *ngIf="items">
                                            <img *ngIf="items.Media && items.Media.length > 0"
                                                [src]="items.Media[0]?.url" class="img-fluid normalimg"
                                                alt="{{ items.title }}" />

                                        </div>
                                        <div class="normalboxDetail">
                                            <!-- <div class="catServices">{{ items?.Industry?.industry_name }}</div> -->
                                            <!-- <h5>{{ items?.title }}
                                            </h5> -->
                                            <h5>
                                                {{ (items?.Category3?.title === 'Other' ? items?.category3_name : items?.Category3?.title) | titlecase }}

                                            </h5>
                                            <!-- <p class="location d-flex align-items-center">
                                                {{items?.UserAuth?.company_name}}

                                            </p> -->

                                            <p class="location d-flex align-items-center">
                                                <span *ngIf=" items?.stateDetails?.name"><img
                                                    src="assets/images/locations.svg"
                                                        class="img-fluid me-2" alt="location"></span>
                                                        <span *ngIf="items?.stateDetails?.name" class="c-price">{{
                                                            items?.cityDetails?.city }}<span
                                                            *ngIf="items?.cityDetails?.city != null && items?.cityDetails?.city != 'null'">,</span> {{
                                                                items?.stateDetails?.name | titlecase }}</span>
                                         
                                            </p>
                                          
                                            

                                              <div class="price" *ngIf="items?.price != 'null' && items?.price != null">
                                                {{ items?.category1_id == '9595821e-9d59-4218-b516-ed77d4aa7a76' ? 'Max Loan Up To' : 'Price' }}
                                                <span class="pricebold c-price">{{ (items?.price) ? (' ₹ ' + (items?.price | commaSeparated)) + "/-" : 'On Request' }}</span>
                                                <!-- <span class="pricebold c-price">{{ items?.price | currency:'INR' :'symbol':'1.0-0' }}/-</span> -->
                                                <!-- <span *ngIf="items?.punit">/{{items?.punit || ''}}</span> -->
                                              </div>  
                                           
                                            <div class="ContactSeller mt-2">
                                                <a> Contact the Seller</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="position-relative py-3 py-sm-5 pb-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3 mb-2 mb-sm-0">
                    <h2> New Arrivals</h2>
                    <p style="opacity: 70%; font-weight: 400;" class="mobile-view-margin">Explore our New Arrivals,
                        featuring the latest and most
                        exciting products. Stay ahead with fresh picks just for you!</p>
                    <a (click)="navigateNewlyArrival()" class="ctabtn" style="display: inline-block;"> View All </a>
                </div>

                <div class="col-md-9 px-0 md-screen-padding">
                    <div class="trsliders">
                        <div class="slick-slider">

                            <div class="trServices" *ngFor="let product_new of homeListdata?.newArrivals"
                                (click)="viewSingleProduct(product_new.id)">
                                <span class="newtick"> New</span>

                                <img *ngIf="product_new.Media && product_new.Media.length > 0"
                                    [src]="product_new.Media[0]?.url" class="product-image img-fluid imgborder"
                                    alt="{{ product_new.title }}" />

                                <div class="trServicesDetail">
                                    <!-- <div class="catServices mb-1"> {{product_new?.Industry?.industry_name}} </div> -->
                                    <!-- <h5 class="mb-1">{{ product_new.title }}</h5> -->
                                    <h5>

                                        {{ (product_new?.Category3?.title === 'Other' ? product_new?.category3_name : product_new?.Category3?.title) | titlecase }}

                                    </h5>

                                    <!-- <p class="location d-flex align-items-center" *ngIf="product_new?.UserAuth?.company_name">
                                       <span> {{product_new?.UserAuth?.company_name}}</span>

                                    </p> -->
                                    <p class="location d-flex align-items-center mb-1"><span
                                            *ngIf="product_new?.stateDetails?.name"><img
                                                src="assets/images/new_img/location.svg" class="img-fluid me-2"
                                                alt="location"></span>
                                     
<span *ngIf="product_new?.stateDetails?.name">{{
    product_new?.cityDetails?.city }}<span
    *ngIf="product_new?.cityDetails?.city != null && product_new?.cityDetails?.city != 'null'">,</span> {{
        product_new?.stateDetails?.name | titlecase }}</span>
                                    </p>
                                    <!-- <div class="price">Price <span>{{ product_new.price }}</span></div> -->

                                   

                                      <div class="price" *ngIf="product_new?.price != 'null' && product_new?.price != null">
                                        {{ product_new?.category1_id == '9595821e-9d59-4218-b516-ed77d4aa7a76' ? 'Max Loan Up To' : 'Price' }}
                                        <span class="pricebold">{{ (product_new?.price) ? (' ₹ ' + (product_new?.price | commaSeparated)) + "/-" : 'On Request' }}</span>
                                        <!-- <span *ngIf="items?.punit">/{{items?.punit || ''}}</span> -->
                                      </div>  

                                   
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="py-1 py-sm-0 res-md-padding">
        <div class="container-fluid">
            <div class="row align-items-center"
                style="background-image: url('assets/images/tellEnquiries.jpg'); border-radius: 8px; background-size: cover; border: 1px solid #00228033;">
                <div class="col-md-5 p-0">
                    <div class="Enquiries">
                        <img src="assets/images/typing-laptops.jpg" class="img-fluid" alt="Enquiries">
                    </div>

                </div>
                <div class="col-md-7">
                    <div class="EnquiriesBox">
                        <h3 class="mt-3 mt-sm-3 mt-md-0"> Tell Us Your Enquiry </h3>
                        <form [formGroup]="Enquiriesfrom" (ngSubmit)="postEnquiriesfrom()">
                            <div class="col-md-12 mb-2">
                                <input type="hidden" class="w-100 locationdata form-control"
                                        formControlName="utm_source" >
                                <input type="hidden" class="w-100 locationdata form-control"
                                        formControlName="utm_medium">
                                <input type="hidden" class="w-100 locationdata form-control"
                                        formControlName="utm_campaign">
                                <input type="hidden" class="w-100 locationdata form-control"
                                        formControlName="utm_term">
                                <input type="hidden" class="w-100 locationdata form-control"
                                        formControlName="utm_content">
                                <input type="hidden" class="w-100 locationdata form-control"
                                        formControlName="utm_placement">
                                </div>
                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata ">
                                    <input type="text" class="w-100 locationdata form-control"
                                        formControlName="full_name" placeholder="First Name*">
                                        <small *ngIf="submitted && Enquiriesfrom.controls['full_name'].hasError('required')">
                                            Name is required
                                          </small>

                                    <!-- <div *ngIf="Enquiriesfrom.get('name')?.errors?.serverError" class="error">
                                        {{ Enquiriesfrom.get('name')?.errors?.serverError }}
                                    </div> -->
                                  
                                </div>
                            </div>

                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata countrycodeBox">
                                    <p class="countrycode"> +91 <img src="assets/icons/arrow.svg" class="" alt="arrow">
                                    </p>
                                    <input type="text" class="w-100 locationdata form-control"
                                        formControlName="mobile_number" placeholder="Enter Mobile Number*"
                                        maxlength="10" (input)="restrictInput($event)" (keydown)="validators.avoidSpace($event)">
                                        <small *ngIf="submitted && Enquiriesfrom.controls['mobile_number'].hasError('required')">
                                            Mobile Number is required
                                          </small>
                                </div>
                            </div>


                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata">
                                    <p class="Offering"> Select Offering*</p>

                                    <div class="customwidth position-relative mb-2 textarea-container mobile-radio-btn">
                                        <div class="radio-button-group">
                                            <label class="radio-button" *ngFor="let items of selectedIndustry">
                                                <input
                                                  type="radio"
                                                  formControlName="industry_id"
                                                  [value]="items.id"
                                                />
                                                <span class="radio-text">{{ items.industry_name }}</span>
                                              </label>
                                        </div>
                                    </div>
                                    <small *ngIf="submitted && Enquiriesfrom.controls['industry_id'].hasError('required')">
                                        Offering is required
                                      </small>
                                </div>
                            </div>

                            <div class="col-md-12 mb-2">
                                <div class="locateyourdata">
                                    <div class="customwidth position-relative mb-2 textarea-container">
                                        <textarea type="text" class="form-control emaildata ps-3"
                                            formControlName="description" maxlength="1500"
                                            placeholder="Enter Your Description*"></textarea>
                                          
                                    </div>
                                    <small *ngIf="submitted && Enquiriesfrom.controls['description'].hasError('required')">
                                        Description is required
                                      </small>
                                </div>
                            </div>



                            <div class="col-md-12">
                                <button type="submit" class="telladdListing mb-sm-2 mb-md-0" name="tellEnquiries">Submit Requirement
                                </button>
                            </div>



                        </form>

                    </div>
                </div>

            </div>
        </div>
    </section>
    <section class="position-relative py-3 py-sm-5" *ngIf="homeListdata?.bestSellersTools?.length >0">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3">
                    <h2> Best Seller Work tools</h2>
                    <p style="opacity: 70%; font-weight: 400;"> Explore the best-selling work tools trusted by
                        professionals worldwide!</p>
                    <a  class="ctabtn"> View All </a>
                </div>

                <div class="col-md-9">
                   
                    <div class="trsliders"> 
                        <div class="slick-slider">
                           
                            <div class="trServices" *ngFor="let bestSellersTools of homeListdata?.bestSellersTools">
                                <span class="newtick"> New</span>
                                <img *ngIf="bestSellersTools.Media && bestSellersTools.Media.length > 0"
                                    [src]="bestSellersTools.Media[0]?.url" class="product-image"
                                    alt="{{ bestSellersTools.title }}" class="product-image img-fluid imgborder"
                                    alt="location" (click)="viewSingleProduct(bestSellersTools.id)">

                                <div class="trServicesDetail">
                                    <div class="catServices"> {{bestSellersTools?.Industry?.industry_name}} </div>
                                    <h5> Metal Welding Services</h5>
                                    <!-- <p class="location d-flex align-items-center" *ngIf="bestSellersTools?.UserAuth?.company_name">
                                        <span> {{bestSellersTools?.UserAuth?.company_name}}</span>
 
                                     </p> -->
                                    <p class="location d-flex align-items-center"><span>
                                            <img src="assets/images/new_images/location.svg" class="img-fluid me-2"
                                                alt="location">
                                        </span> <span> {{ bestSellersTools.location }} </span> </p>
 

                                          <div class="price" *ngIf="bestSellersTools?.price != 'null' && bestSellersTools?.price != null">
                                            {{ bestSellersTools?.category1_id == '9595821e-9d59-4218-b516-ed77d4aa7a76' ? 'Max Loan Up To' : 'Price' }}
                                            <!-- <span class="pricebold">{{ bestSellersTools?.price | currency:'INR' :'symbol':'1.0-0' }}/-</span> -->
                                            <span class="pricebold">{{ (bestSellersTools?.price) ? (' ₹ ' + (bestSellersTools?.price | commaSeparated)) + "/-" : 'On Request' }}</span>
                                            <!-- <span *ngIf="items?.punit">/{{items?.punit || ''}}</span> -->
                                          </div>  

                                </div>

                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </section>
    <section class="py-3 py-sm-5">
        <div class="container-fluid">
            <div class="row align-items-center"
                style="background-image: url('/assets/images/Industrialbg.jpg');  align-items: stretch !important;     border-radius: 8px;">
                <div class="col-md-4 p-0">
                    <div class="boxbg" style="height: 100%; border-radius: 8px 0px 0px 8px;">
                        <div class="catServices"> Services </div>
                        <h2> Top Rated Services</h2>
                        <p style="opacity: 70%; font-weight: 400;">Upgrade your efficiency with our Best Seller Work
                            Tools, trusted by professionals. Get the tools that deliver top performance every time!</p>

                        <a  class="ctabtn ctabtnbg"> View All </a>
                    </div>
                </div>
                <div class="col-md-8 p-0">
                    <div class="IndustrialServices">
                        <img src="assets/images/industrial-engineer.jpg" class="img100 img-fluid border16 "
                            alt="Industrial Services" style="border-radius: 0px 8px 8px 0px;">
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="position-relative py-3 py-sm-5 pb-5 tb-mdscreen-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3 mb-2 mb-sm-0">
                    <h2> Top Imported Products</h2>
                    <p style="opacity: 70%; font-weight: 400;" class="mobile-view-margin"> Discover premium imported
                        products handpicked for
                        quality and style!</p>
                    <a (click)="navigateToDetails('Imported')" class="ctabtn" style="display: inline-block;"> View All </a>
                </div>

                <div class="col-md-9 px-0 md-screen-padding">
                    <div class="trsliders">
                        <div class="slick-slider">
                            
                            <div class="trServices"
                                *ngFor="let topImportedProducts of homeListdata?.topImportedProducts" (click)="viewSingleProduct(topImportedProducts.id)">
                              
                                
                                <span class="newtick" *ngIf="topImportedProducts?.is_new === true">New</span>

                                <img *ngIf="topImportedProducts.Media && topImportedProducts.Media.length > 0"
                                    [src]="topImportedProducts.Media[0]?.url" class="product-image"
                                    alt="{{ topImportedProducts.title }}" class="product-image img-fluid imgborder"
                                    alt="location">
                                <div class="trServicesDetail">
                                    <div class="catServices mb-1"> {{ topImportedProducts.product_category_name | titlecase }}
                                    </div>
                                    <!-- <h5 class="mb-1"> {{ topImportedProducts.title }}</h5> -->
                                    <h5>
{{ (topImportedProducts?.Category3?.title === 'Other' ? topImportedProducts?.category3_name : topImportedProducts?.Category3?.title) | titlecase }}
                                    </h5>

                                    <!-- <p class="location d-flex align-items-center" *ngIf="topImportedProducts?.UserAuth?.company_name">
                                        <span> {{topImportedProducts?.UserAuth?.company_name}}</span>
 
                                     </p> -->

                                    <!-- <p class="location d-flex align-items-center mb-1"><span>
                                            <img src="assets/images/new_images/location.svg" class="img-fluid me-2"
                                                alt="location">
                                        </span><span> {{ topImportedProducts.location }} </span>
                                    </p> -->
                                    <p class="location d-flex align-items-center">
                                        <span *ngIf="topImportedProducts.country_origin">
                                            <img
                                            src="assets/images/new_images/location.svg" class="img-fluid me-2"
                                                alt="location">
                                            </span>
                                        <span *ngIf="topImportedProducts?.country_origin">
                                            Made in {{topImportedProducts?.country_origin | titlecase}}
                                            </span>
                                    </p>

                                    <!-- <div class="price">Price <span>₹{{ topImportedProducts.price }} </span></div>{{
                                            topImportedProducts?.cityDetails?.city }},{{
                                            topImportedProducts?.stateDetails?.name }} -->

                                          
                                              <div class="price" *ngIf="topImportedProducts?.price != 'null' && topImportedProducts?.price != null">
                                                {{ topImportedProducts?.category1_id == '9595821e-9d59-4218-b516-ed77d4aa7a76' ? 'Max Loan Up To' : 'Price' }}
                                                <!-- <span class="pricebold">{{ topImportedProducts?.price | currency:'INR' :'symbol':'1.0-0' }}/-</span> -->
                                                <span class="pricebold">{{ (topImportedProducts?.price) ? (' ₹ ' + (topImportedProducts?.price | commaSeparated)) + "/-" : 'On Request' }}</span>
                                                <!-- <span *ngIf="items?.punit">/{{items?.punit || ''}}</span> -->
                                              </div>  

                                   
                                </div>
                            </div>
                        </div>
                        <!-- <button type="button" class="slick-prev"><img src="assets/images/new_images/arrow-left.svg"
                                class="" alt=""></button>
                        <button type="button" class="slick-next"><img src="assets/images/new_images/arrow-right.svg"
                                class="" alt=""></button> -->
                    </div>
                </div>


            </div>
        </div>
    </section>
    <section class="my-3" *ngIf="homeListdata?.featuredProduct?.length >0">
        <div class="container-fluid py-sm-5 pt-0 pb-4 bgBlue" style="border-radius: 8px;">
            <div class="row">
                <div class="col-md-12 p-3 text-center colorwhite">
                    <h2 style="color: #fff !important;"> Featured Listings</h2>
                </div>
                <div class="col-md-12">
                    <div class="slidera">
                        <div class="featuredlistings-slide">

                            <div class="trServices text-start"
                                *ngFor="let featuredProduct of homeListdata?.featuredProduct || []" (click)="viewSingleProduct(featuredProduct.id)">
                               
                                <span class="newtick" *ngIf="featuredProduct?.is_new === true">Top Seller</span>
                                <!-- <img src="assets/images/new_images/featured.jpg" class="img-fluid imgborder" alt="Rated"> -->
                                <div class="FeaturedimgBox">
                                    <img *ngIf="featuredProduct.Media && featuredProduct.Media.length > 0"
                                        [src]="featuredProduct.Media[0]?.url" class="product-image"
                                        alt="{{ featuredProduct.title }}" class="img-fluid imgborder" alt="Rated"
                                        >
                                </div>
                                <div class="trServicesDetail">
                                    <!-- <div class="catServices"> {{featuredProduct?.Industry?.industry_name}} </div> -->
                                    <h5 class="size30">
                                        {{ (featuredProduct?.Category3?.title === 'Other' ? featuredProduct?.category3_name : featuredProduct?.Category3?.title) | titlecase }}

</h5>
                                        <p class="colorwhites mb-1">
<!--                                         
                                        <span style="    font-size: 19px;">    {{featuredProduct?.UserAuth?.company_name}}
                                        </span><br/>
                                         -->
                                        <p class="location d-flex align-items-center mb-3" *ngIf="featuredProduct?.stateDetails?.name">
                                            <span>
                                                <img
                                                src="assets/images/new_images/location.svg" class="img-fluid me-2"
                                                    alt="location" style="width:16px !important;">
                                                </span>

                                                <span style="font-size: 15px;" *ngIf="featuredProduct?.stateDetails?.name">{{
                                                    featuredProduct?.cityDetails?.city }}<span
                                                    *ngIf="featuredProduct?.cityDetails?.city != null && featuredProduct?.cityDetails?.city != 'null'">,</span> {{
                                                        featuredProduct?.stateDetails?.name | titlecase }}</span>
                                        </p>
 
                                       
                                           
                                          <div class="price" *ngIf="featuredProduct?.price != 'null' && featuredProduct?.price != null">
                                            {{ featuredProduct?.category1_id == '9595821e-9d59-4218-b516-ed77d4aa7a76' ? 'Max Loan Up To' : 'Price' }}
                                            <!-- <span class="pricebold">{{ featuredProduct?.price | currency:'INR' :'symbol':'1.0-0' }}/-</span> -->
                                            <span class="pricebold">{{ (featuredProduct?.price) ? (' ₹ ' + (featuredProduct?.price | commaSeparated)) + "/-" : 'On Request' }}</span>
                                            <!-- <span *ngIf="items?.punit">/{{items?.punit || ''}}</span> -->
                                          </div>  
                                            
                                            <div class="ContactSeller mt-2">
                                                <a style="    color: #ee7402;
                                                font-weight: 500;
                                                font-size: 20px;
                                            "> Contact the Seller</a>
                                            </div>
                                    </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="position-relative py-3 py-sm-5 pb-5 tb-mdscreen-padding">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3 mb-2 mb-sm-0">
                    <img src="assets/images/made_in_india_logo.svg" class="img-fluid" alt="made-india">
                    <h2> Products Made In India</h2>
                    <p style="opacity: 70%; font-weight: 400;" class="mobile-view-margin">Celebrate quality and
                        tradition with our Made in India
                        products. Support local excellence!</p>
                    <a (click)="navigateToDetails('India')" class="ctabtn" style="display: inline-block;"> View All </a>
                </div>

                <div class="col-md-9 md-screen-padding">
                    <div class="trsliders">
                        <div class="slick-slider">

                            <div class="trServices"
                                *ngFor="let madeInIndiaProducts of homeListdata?.madeInIndiaProducts" (click)="viewSingleProduct(madeInIndiaProducts.id)">
                                

                                <span class="newtick" *ngIf="madeInIndiaProducts?.is_new === true">New</span>
                                <img *ngIf="madeInIndiaProducts.Media && madeInIndiaProducts.Media.length > 0"
                                    [src]="madeInIndiaProducts.Media[0]?.url" class="product-image"
                                    alt="{{ madeInIndiaProducts.title }}" class="product-image img-fluid imgborder"
                                    alt="location" >

                                <div class="trServicesDetail">
                                    <!-- <div class="catServices mb-1"> {{ madeInIndiaProducts.product_category_name }} </div> -->
                                    <!-- <h5 class="mb-1"> {{ madeInIndiaProducts.title }}</h5> -->
                                    <h5>
                                       

                                        {{ (madeInIndiaProducts?.Category3?.title === 'Other' ? madeInIndiaProducts?.category3_name : madeInIndiaProducts?.Category3?.title) | titlecase }}
                                    </h5>
                                    <!-- <p class="location d-flex align-items-center mb-1"><span>
                                            <img src="assets/images/new_images/location.svg" class="img-fluid me-2"
                                                alt="location">
                                        </span> <span> {{ madeInIndiaProducts.location }} </span>
                                    </p> -->

                                    <!-- <p class="location d-flex align-items-center" *ngIf="madeInIndiaProducts?.UserAuth?.company_name">
                                        <span> {{madeInIndiaProducts?.UserAuth?.company_name}}</span>
 
                                     </p> -->

                                    <p class="location d-flex align-items-center">
                                        <span *ngIf="madeInIndiaProducts.stateDetails?.name"><img
                                                src="assets/images/new_images/location.svg"
                                                class="img-fluid me-2"
                                                alt="location"></span>

                                                <span *ngIf="madeInIndiaProducts?.stateDetails?.name">{{
                                                    madeInIndiaProducts?.cityDetails?.city }}<span
                                                    *ngIf="madeInIndiaProducts?.cityDetails?.city != null && madeInIndiaProducts?.cityDetails?.city != 'null'">,</span> {{
                                                        madeInIndiaProducts?.stateDetails?.name | titlecase }}</span>

                                    </p>
                                    
                                    <div class="price" *ngIf="madeInIndiaProducts?.price != 'null' && madeInIndiaProducts?.price != null">
                                        {{ madeInIndiaProducts?.category1_id == '9595821e-9d59-4218-b516-ed77d4aa7a76' ? 'Max Loan Up To' : 'Price' }}
                                        <!-- <span class="pricebold">{{ madeInIndiaProducts?.price | currency:'INR' :'symbol':'1.0-0' }}/-</span> -->
                                        <span class="pricebold">{{ (madeInIndiaProducts?.price) ? (' ₹ ' + (madeInIndiaProducts?.price | commaSeparated)) + "/-" : 'On Request' }}</span>
                                        <!-- <span *ngIf="items?.punit">/{{items?.punit || ''}}</span> -->
                                      </div>  
 
                                </div>
                            </div>
                        </div>
                        <!-- <button type="button" class="slick-prev"><img src="assets/images/new_images/arrow-left.svg"
                                class="" alt=""></button>
                        <button type="button" class="slick-next"><img src="assets/images/new_images/arrow-right.svg"
                                class="" alt=""></button> -->
                    </div>
                </div>


            </div>
        </div>
    </section>
    <section class="res-md-padding">
        <div class="container-fluid">
            <div class="row mb-5 mb-sm-0">
                <div class="col-md-6 mb-2 mb-sm-2 mb-md-0 md-screen-padding">
                    <div class="PremiereBox position-relative">
                        <img src="assets/images/modern-factory-worker.jpg" class="img100 imgborder img-fluid"
                            alt="Premiere">
                        <!-- <img src="{{bannerListview?.[1]?.[0]?.image}}" class="img100 imgborder img-fluid"
                        alt="Premiere">
                         -->
                        <div class="PremiereBoxinner">
                            <div class="">
                                
                                <h3 class="text-capitalize newone"> Services</h3> 
                                <h3 class="text-capitalize whiteColor mb-4"> Outsourcing/Contract <br/>Manufacturers</h3>
                                <a  href="/main/product-listing?industryId=0627f25d-6d56-4237-b561-d0ea9830acd7&subCategory1Id=31dcdb22-05c4-4a27-8481-3afbee03e8d4" class="abackground" style="    color: #FFF;"> Explore Now</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 md-screen-padding">
                    <div class="PremiereBox position-relative">
                        <!--                     
                    <img src="{{bannerListview?.[1]?.[1]?.image}}" class="img100 imgborder img-fluid"
                        alt="Premiere"> -->
                        <img src="assets/images/engineer-use.jpg" class="img100 imgborder img-fluid"
                            alt="Premiere">
                        <div class="PremiereBoxinner">
                            <div class=""> 
                                <h3 class="text-capitalize newone"> Blogs</h3> 
                                <h3 class="text-capitalize whiteColor mb-4"> Insights. Trends.<br/> Growth.</h3>
                                <a  href="/blogs" class="abackground" style="    color: #FFF;"> Explore Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>



    <!--   

<section class="py-5">
    <div class="container-fluid">
        <div class="row justify-content-between">
            <div class="col-md-12 text-center py-2">
                <h2> View by Brand </h2>
            </div>
        </div>
        <div class="outer-container">
            <div class="row">
                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo1.png" alt="BASF" class="brand-logo">
                </div>
                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo2.png" alt="3M" class="brand-logo">
                </div>
                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo3.png" alt="Audi" class="brand-logo">
                </div>
                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo4.png" alt="ExxonMobil" class="brand-logo">
                </div>
                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo5.png" alt="PepsiCo" class="brand-logo">
                </div>

                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo2.png" alt="PepsiCo" class="brand-logo">
                </div>

                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo1.png" alt="PepsiCo" class="brand-logo">
                </div>

                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo1.png" alt="PepsiCo" class="brand-logo">
                </div>

                <div class="col-md-2 col-sm-4 col-6 brand-box">
                    <img src="assets/images/new_images/logo1.png" alt="PepsiCo" class="brand-logo">
                </div>


            </div>

        </div> 
    </div>
</section> -->


 


    <section class="bgcolor py-3 py-sm-5 mt-sm-4 mt-1 mb-2 mb-sm-0"
        style="background-image: url('assets/images/new_images/testimonials.jpg'); background-size: cover; border: 1px solid #0000001A; border-radius: 8px;">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12 text-center ">
                    <h2> Testimonials </h2>
                </div>
                <div class="col-md-12 ps-5 custome-mob-view">
                    <div class="testimonials-slide">

                        <div class="item" *ngFor="let product of homeListdata?.testimonials">
                            <div class="Testimonialsbox">
                                <div class="Testimonialsinfo">
                                    <p class="nametest"> <b>{{ product.full_name }}</b> </p>
                                    <p class="profiletest"> {{ product.company_name }} </p>
                                </div>
                                <p>{{product.description}}</p>
                            </div>
                        </div>
 
                    </div>
                </div>
            </div>
        </div>

    </section>


    <section style="background-image: url('assets/images/enquiry.jpg'); border-radius: 8px; background-size: cover; "
        class="py-3 py-sm-5 mt-sm-3 mt-1 mb-sm-5 mb-1">
        <div class="container-fluid py-5">
            <div class="row">
                <div class="col-md-12">
                    <div class="ctabox">
                        <h3 style="color: #fff !important;"> Tell us your Enquiry</h3>
                        <!-- <a href="" class="btn"> Post Your Enquiries</a> -->
                        <button name="tellEnquiries" class="telladdListing" style="background-color: #FF642B;     color: #fff;
                                padding: 8px 15px;
                                border-radius: 8px;  
  
  " (click)="enquiry()">Post Your Enquiries </button>
                    </div>
                </div>
            </div>
        </div>
    </section>

</section>
<div>
    <app-footer></app-footer>
</div>